import React from 'react'
import { LuBadgeInfo, LuEye, LuFileEdit, LuTrash2, LuEyeOff } from 'react-icons/lu'
import { Tooltip } from 'react-tooltip'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { DeleteVendorVehicleRes, DeleteVendorVehicleTodo } from '../../../../redux/slices/user managment/venders/DeleteVendorVehicle'

export default function VenderVehicleListAction(props) {
    const { bool, setBool, vehicle1, setVehicle1, setVehicleID } = props
    const navigate = useNavigate()
    const dispatch = useDispatch()



    const vendor_vehicle_details = () => {
        navigate('../vendor-vehicle-details', { state: props?.data?.id })
    }

    const edit_action = () => {
        setVehicle1(true)
        setVehicleID(props?.data?.id)
    }

       const del_action = () => {
            Swal.fire({
                title: "Vehicle Delete",
                text: "Are You Sure Want To Delete This Vehicle ?",
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#121136',
                cancelButtonColor: '#EF3D50',
                cancelButtonText: 'Cancel',
                confirmButtonText: 'Delete'
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(DeleteVendorVehicleTodo(props?.data?.id)).then(() => del_res())
                }
            })  
        }
        const del_res = () => {
            if (DeleteVendorVehicleRes?.success) {
                setBool(!bool)
                Swal.fire(
                    "Vehicle",
                    'Vehicle Deleted Successfully',
                    'success'
                )
            } else {
                toast.error(DeleteVendorVehicleRes?.message, { position: "bottom-right" })
            }
        }


    return (
        <>
            <div>
                <LuFileEdit size={20} className='edit text-success '
                    onClick={() => edit_action()}
                    data-tooltip-id='edit'
                    data-tooltip-content="Edit Vehicle!"
                    data-tooltip-place="bottom"
                />
                <LuBadgeInfo size={20} className='details text-primary ms-2'
                    onClick={() => vendor_vehicle_details()}
                    data-tooltip-id='details'
                    data-tooltip-content=" Vehicle Details!"
                    data-tooltip-place="bottom"
                />
                <LuTrash2 size={20} className='delete text-danger ms-2'
                    onClick={() => del_action()}
                    data-tooltip-id='del'
                    data-tooltip-content="Delete Vehicle!"
                    data-tooltip-place="bottom"
                />

                <Tooltip id='edit' className='bg-success tooltip_msg' />
                <Tooltip id='del' className='bg-danger tooltip_msg' />
                <Tooltip id='details' className='bg-primary tooltip_msg' />
                <Tooltip id='active' className='bg-secondary tooltip_msg' />
                <Tooltip id='deactivate' className='bg-secondary tooltip_msg' />

            </div>
        </>
    )
}
